if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.autoAdvanceMs = 3000;
        this.autoTimer = null;
        this.currentIndex = 0;
      }

      connectedCallback() {
        this.prevButton = this.querySelector('.kw-product-modal__prev');
        this.nextButton = this.querySelector('.kw-product-modal__next');

        this.prevButton?.addEventListener('click', () => {
          this.showRelative(-1);
          this.restartAutoAdvance();
        });

        this.nextButton?.addEventListener('click', () => {
          this.showRelative(1);
          this.restartAutoAdvance();
        });

        this.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open')) return;
          if (event.key === 'ArrowLeft') {
            this.showRelative(-1);
            this.restartAutoAdvance();
          }
          if (event.key === 'ArrowRight') {
            this.showRelative(1);
            this.restartAutoAdvance();
          }
        });
      }

      getMediaItems() {
        return Array.from(this.querySelectorAll('.product-media-modal__content [data-media-id]'));
      }

      hide() {
        this.stopAutoAdvance();
        this.pauseAllVideos();
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.startAutoAdvance();
      }

      showActiveMedia() {
        const mediaId = this.openedBy?.getAttribute('data-media-id');
        const items = this.getMediaItems();
        if (!items.length) return;

        let index = items.findIndex((item) => item.getAttribute('data-media-id') === mediaId);
        if (index < 0) index = 0;
        this.showMediaAt(index);
      }

      showMediaAt(index) {
        const items = this.getMediaItems();
        if (!items.length) return;

        this.currentIndex = (index + items.length) % items.length;

        items.forEach((item, itemIndex) => {
          item.classList.toggle('active', itemIndex === this.currentIndex);
          item.setAttribute('aria-hidden', itemIndex === this.currentIndex ? 'false' : 'true');
        });

        const activeMedia = items[this.currentIndex];

        this.pauseAllVideos(activeMedia);

        if (activeMedia.nodeName === 'DEFERRED-MEDIA') {
          activeMedia.loadContent();
        }

        this.autoplayMedia(activeMedia);

        const container = this.querySelector('[role="document"]');
        if (container) {
          container.scrollTop = 0;
          container.scrollLeft = 0;
        }

        const shouldShowNav = items.length > 1;
        if (this.prevButton) this.prevButton.hidden = !shouldShowNav;
        if (this.nextButton) this.nextButton.hidden = !shouldShowNav;
      }

      showRelative(direction) {
        this.showMediaAt(this.currentIndex + direction);
      }

      pauseAllVideos(except = null) {
        this.getMediaItems().forEach((item) => {
          if (item === except) return;

          item.querySelectorAll('video').forEach((video) => {
            video.pause();
          });

          item.querySelectorAll('iframe').forEach((iframe) => {
            try {
              iframe.contentWindow?.postMessage(
                JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }),
                '*'
              );
            } catch (error) {}
          });
        });
      }

      autoplayMedia(activeMedia) {
        const play = () => {
          const video = activeMedia.querySelector('video');
          if (video) {
            video.muted = true;
            video.playsInline = true;
            const promise = video.play();
            if (promise?.catch) promise.catch(() => {});
            return;
          }

          const iframe = activeMedia.querySelector('iframe');
          if (iframe) {
            try {
              const url = new URL(iframe.src, window.location.href);
              url.searchParams.set('autoplay', '1');
              url.searchParams.set('mute', '1');
              url.searchParams.set('muted', '1');

              if (iframe.src !== url.toString()) {
                iframe.src = url.toString();
              }
            } catch (error) {}
          }
        };

        window.requestAnimationFrame(() => {
          play();
          window.setTimeout(play, 120);
        });
      }

      startAutoAdvance() {
        this.stopAutoAdvance();
        if (this.getMediaItems().length < 2) return;
        this.autoTimer = window.setInterval(() => this.showRelative(1), this.autoAdvanceMs);
      }

      stopAutoAdvance() {
        if (this.autoTimer) {
          window.clearInterval(this.autoTimer);
          this.autoTimer = null;
        }
      }

      restartAutoAdvance() {
        this.startAutoAdvance();
      }
    }
  );
}
